"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = _interopRequireDefault(require("../utils/prop-types"));

var _mimeType = _interopRequireDefault(require("../utils/mime-type"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ItemDetailView = /*#__PURE__*/function (_React$Component) {
  _inherits(ItemDetailView, _React$Component);

  var _super = _createSuper(ItemDetailView);

  function ItemDetailView() {
    _classCallCheck(this, ItemDetailView);

    return _super.apply(this, arguments);
  }

  _createClass(ItemDetailView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var item = this.props.item;

      if (item.mimeType === _mimeType["default"].EMBED) {
        window.DGS.Event.getInstance().trigger('link-embed-code-detected'); // activate the video spot overlay
      }
    }
  }, {
    key: "blockClick",
    value: function blockClick(e) {
      e.stopPropagation();
    }
  }, {
    key: "openItem",
    value: function openItem(e) {
      e.preventDefault();
      var item = this.props.item;

      if (item.mimeType !== _mimeType["default"].EMBED) {
        window.open(item.url, '_blank');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          item = _this$props.item,
          dictionary = _this$props.dictionary,
          onClose = _this$props.onClose;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "detail-lightbox outer-container",
        onClick: onClose,
        onKeyUp: onClose,
        role: "button",
        tabIndex: "-20"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "inner-container",
        onClick: function onClick(e) {
          return _this.blockClick(e);
        },
        onKeyUp: function onKeyUp(e) {
          return _this.blockClick(e);
        },
        role: "button",
        tabIndex: "-10"
      }, item.image && /*#__PURE__*/_react["default"].createElement("div", {
        className: "lightbox-fileimg",
        style: {
          backgroundImage: "url(".concat(item.image, ")")
        }
      }), /*#__PURE__*/_react["default"].createElement("h4", {
        className: "lightbox-filename"
      }, item.name), /*#__PURE__*/_react["default"].createElement("div", {
        className: "lightbox-filedescription"
      }), /*#__PURE__*/_react["default"].createElement("a", {
        className: "lightbox-download",
        href: item.mimeType === _mimeType["default"].EMBED ? '' : item.url,
        rel: "noopener noreferrer",
        target: "_blank",
        title: item.mimeType === _mimeType["default"].EMBED ? item.url : item.name,
        onClick: function onClick(e) {
          return _this.openItem(e);
        }
      }, item.mimeType === _mimeType["default"].EMBED ? dictionary.embed : dictionary.download), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "lightbox-close",
        "aria-label": "close",
        onClick: onClose,
        onKeyUp: onClose,
        tabIndex: "-10"
      })));
    }
  }]);

  return ItemDetailView;
}(_react["default"].Component);

ItemDetailView.propTypes = {
  dictionary: _propTypes2["default"].dictionary.isRequired,
  item: _propTypes2["default"].item.isRequired,
  onClose: _propTypes["default"].func.isRequired
};
var _default = ItemDetailView;
exports["default"] = _default;